<template>
    <div class="login">
        <div class="loginB">
            <div class="loginImg">
                <img src="@/assets/images/login.png" alt="">
            </div>
            <div class="loginForm">
                <img src="@/assets/images/logo1.png" alt="">
                <div class="formBox">
                    <p class="title">
                        <span :class="{'active':role == 1}">流量主</span>
                        <!-- <span @click="roleChange(1)" :class="{'active':role == 1}">流量主</span> -->
                        <!-- <span @click="roleChange(2)" :class="{'active':role == 2}" style="margin-left: 24px;">广告主</span> -->
                    </p>
                    <form class="form" action="/" method="POST" id="loginForm">
                        <input placeholder="用户名" type="text" v-model="formValue.username" name="username">
                        <input placeholder="密码" type="password" v-model="formValue.password" name="password">
                        <div class="codeBox">
                            <input class="wd200" placeholder="验证码" v-model="formValue.verifyvalue" type="password" name="code">
                            <img @click="getVerifCode()" class="codeImg" :src="codeImg" alt="">
                        </div>
                        <input :class="{'btn':true,'loginClick':loginState==1}" @click="login($event)" type="button" :value="loginState==1?'登录中...':'登录'">
                        <p v-if="errorMsg" class="errorMsg">{{errorMsg}}</p>
                    </form>
                </div>
                
            </div>
        </div>
        <div class="botSign">
            <ul>
                <li v-for="(key,index) in $t('login.projectList')" :key = "index">
                    <router-link v-if="key.path" :to="key.path">{{key.name}}</router-link>
                    <a v-else :href="key.href" target="_black">{{key.name}}</a>
                </li>
            </ul>
            <p>{{$t('login.msg')}}</p>
        </div>
    </div>
</template>
<script>
    const Base64 = require('js-base64').Base64;
    export default {
        name:"login",
        data(){
            return{
                role:1,
                loginState:0,
                codeImg:'',
                codeId:'',
                formValue:{username:'',password:'',verifyvalue:'',imagekeyId:''},
                errorMsg:'',
                loginURL:'https://channel.xingchenjia.com/auth/login',
                homeURL:'http://channel.xingchenjia.com/#/login',
                codeURL:"https://channel.xingchenjia.com/auth/getCaptcha"
            }
        },
        created () {
            this.getVerifCode()
        },
        methods: {
            // roleChange(value){
            //     this.role = value;
            //     this.homeURL = this.role == 1 ? 'http://channel.xingchenjia.com/#/login' : "http://advertiser.iscrv.com/#/dash/board"
            //     this.loginURL = this.role == 1 ? "https://channel.xingchenjia.com/auth/login" : "https://advertiser.iscrv.com/auth"
            //     this.codeURL = this.role == 1 ? "https://channel.xingchenjia.com/auth/getCaptcha" : "https://advertiser.iscrv.com/captcha"
            //     this.formReset();
            //     this.getVerifCode()
            // },
            formReset(){
                this.formValue = {username:'',password:'',verifyvalue:'',imagekeyId:''}
            },
            login(){
                this.loginState = 1;
                let self = this;
                let obj = {}
                if(this.role == 1){
                    this.formValue.imagekeyId = this.codeId;
                    obj = this.formValue;
                }else{
                    obj={
                        image_id:self.codeId,
                        password : Base64.encode(self.formValue.password),
                        user_name : self.formValue.username,
                        verify_value : self.formValue.verifyvalue
                    }
                }
                this.$http.post(self.loginURL,JSON.stringify(obj)).then((res)=>{
                    self.loginState = 0;
                    if(res.code == 200){
                        let username = obj.username ? obj.username : obj.user_name;
                        let params = self.role == 1 ? "?token=" + res.data +"&username=" + username :"?advertiser=" + res.data +"&username=" + username;
                        let targetUrl = `${self.homeURL}` + params
                        window.open(targetUrl, '_blank')
                    }else if((self.role==1&&res.code==409)||(self.role==2&&res.code==400)){                        
                        self.errorMsg = res.msg;
                        self.loginState = 0;
                        self.getVerifCode()
                    }else{
                        self.errorMsg = res.msg;
                        self.loginState = 0;
                    }
                })
            },
            getVerifCode(){
                let self = this;              
                this.$http.get(self.codeURL).then((res)=>{
                    if(res.code==200){
                        let data = res.data
                        self.codeImg = self.role == 1 ? data.imagebase64 : data.image_base64;
                        self.codeId = self.role == 1 ? data.imagekeyId : data.image_id;
                    }
                }).catch((error)=>{
                    console.log("resresresres",error)
                })
            },
        }
    }
</script>
<style lang="scss" scoped> 
.login{
    width: 100%;
    height: 100%;
    background:linear-gradient(138deg,rgba(254,255,255,1) 0%,rgba(235,238,242,1) 100%);
}
    .loginB{
        width: 1110px;
        display: flex;
        flex-direction: row;
        position: fixed;
        top: 40%;
        left: 50%;
        transform: translate(-50%,-50%);
        .loginForm{
            display: flex;
            flex-direction:column;
            align-items:center;
            margin-left:68px;
            .formBox{
                margin-top: 24px;
                padding:23px 35px 35px 35px;
                background: #fff;
                p{
                    text-align:center;
                    font-size:18px;
                    font-family:PingFangSC-Semibold,PingFang SC;
                    font-weight:600;
                    color:rgba(182,185,193,1);
                    span{
                        cursor: pointer;
                    }
                    .active{
                        font-size:18px;
                        text-align: center;
                        font-family:PingFangSC-Semibold,PingFang SC;
                        font-weight:600;
                        color:rgba(0,161,255,1);
                        line-height:25px;
                        // border-bottom: 3px solid rgba(0,161,255,1);
                    }
                }
                .form{
                    width: 340px;
                    margin-top: 15px;
                    input{
                        width:340px;
                        height:46px;
                        background:rgba(249,249,249,1);
                        border-radius:4px;
                        border:none;
                        margin-top:14px;
                        padding-left:20px;
                    }
                    .btn{
                        width:340px;
                        height:50px;
                        background:linear-gradient(135deg,rgba(54,190,250,1) 0%,rgba(18,121,219,1) 100%);
                        border-radius:4px;
                        color: #fff;
                        outline:none;
                        padding-left:0 ;
                        &:hover{
                            background:linear-gradient(135deg,rgba(84,202,255,1) 0%,rgba(45,155,255,1) 100%);
                            color: #fff;
                        }
                    }
                    .loginClick{
                        background:rgba(12,111,202,1);
                        color:rgba(105,176,241,1);
                    }
                    .errorMsg{
                        margin-top: 10px;
                        font-size:14px;
                        font-family:PingFangSC-Regular,PingFang SC;
                        font-weight:400;
                        color:rgba(243,77,77,1);
                        line-height:20px;
                    }
                    .codeBox{
                        width:340px;
                        height:64px;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        .codeImg{
                            width: 120px;
                            height:50px;
                            margin-top:14px;
                            /* margin-left: 20px; */
                        }
                    }
                    
                }
            }
        }
    }
    .botSign{
        position: fixed;
        bottom: 61px;
        width:100%;
        ul{
            display: flex;
            flex-direction:row;
            justify-content:center;
            li{
                margin-left: 20px;
                a{
                    color: #222;
                }
            }
        }
        p{
            text-align: center;
            margin-top: 20px;
        }
    }
</style>